import axios from "axios";

// Lokal: in .env.local  NEXT_PUBLIC_API_URL=http://localhost:7004
const axiosJWT = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || "https://car-db.aundoautoservice.de",
  withCredentials: true,
});

export default axiosJWT;